export default __webpack_public_path__ + "static/media/logo.89e1a838.png";